import React from "react";
import Alert from "@mui/material/Alert";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { useInboxAddress, useInboxNotice } from "@seabrookstudios/pitch2table";
import { AlwaysOnAppLink } from "../styleguide/AppLink";
import { Path } from "../Path";

export const InboxListHeader = () => {
  const notice = useInboxNotice();
  const { data: address, isLoading } = useInboxAddress();

  if (isLoading) {
    return (
      <Stack spacing={1} p={1} pb={0}>
        <Skeleton height={48} />
      </Stack>
    );
  }

  if (!address?.email) {
    return (
      <Stack spacing={1} p={1} pb={0}>
        <Alert severity="warning">
          Use the Pitch2Table inbox email address to capture publisher responses and link them to your publisher
          submissions. No inbox address set up. Set one up in{" "}
          <AlwaysOnAppLink to={Path.settings().category("email-inbox")}>Email Inbox settings</AlwaysOnAppLink> to use
          this feature.
        </Alert>
      </Stack>
    );
  }

  return (
    <Stack spacing={1} p={1} pb={0}>
      <Alert severity="info">{notice}</Alert>
    </Stack>
  );
};
